module.exports = __webpack_public_path__ + "img/7.cab13d53.png";